// ----------------------------------------------------------------------
// CUSTOM CHANGES
// - shape extension path change
// - added U21Shape

import { Shape as MuiShape } from '@mui/system/createTheme/shape';

interface CustomShape {
  borderRadiusSm: number;
  borderRadiusMd: number;
}

export interface U21Shape extends MuiShape, CustomShape {}

declare module '@mui/system/createTheme/shape' {
  interface Shape extends CustomShape {}
}

const shape = {
  borderRadius: 8,
  borderRadiusSm: 12,
  borderRadiusMd: 16,
};

export default shape;
